export default String.raw`
.category-description{
    &__title-container{
        margin: 15px;
    }
    &__container{
        flex-direction: column;
        .image-container{
            width: 100%;
        }
        .description-container{
            padding: 15px;
            order: 2;
            width: 100%;
        }
    } 
}
`